import WebHttpClient from '~src/httpClient/WebHttpClient';

import { GetTaskDetailsRequest } from '../requests/GetTaskDetailsRequest';
import { ITaskDetailsResult } from '../types/ITaskDetails';

/**
 * Business logic for fetching Task Details (S05-b). Wraps the {@link GetTaskDetailsRequest}
 * HTTP call so the container does not talk to the request layer directly. Mirrors the
 * non-saga service pattern used by `AdminProfilesService`.
 */
export namespace TaskDetailsService {
  export function getTaskDetails(taskLuid: string): Promise<ITaskDetailsResult> {
    return WebHttpClient.sendRequest(new GetTaskDetailsRequest({ taskLuid }));
  }
}
